import Settings from "../components/settings";
import SvgIcons from "../../../shared/components/svgIcons";

const settingsRoute = [
  {
    path: "settings",
    element: <Settings />,
    link: "settings",
    name: "Settings",
    permission: "Settings",
    icon: SvgIcons.SettingsIcon,
    index: 4,
  },
];
export default settingsRoute;
